export const archiveList = [
  {
    title: '2022 소프트웨어 카탈로그',
    file: '2022 소프트웨어 카탈로그',
    extension: 'pdf',
    description: '',
    size: '3.5',
  },
  {
    title: '2022 하드웨어 카탈로그',
    file: '2022 하드웨어 카탈로그',
    extension: 'pdf',
    description: '',
    size: '3.4',
  },
  {
    title: '담배 자판기 브로슈어',
    file: '담배 자판기 브로슈어',
    extension: 'pdf',
    description: '',
    size: '4',
  },
  {
    title: '마라탕 키오스크 매뉴얼',
    file: '마라탕 키오스크 매뉴얼',
    extension: 'zip',
    description: '',
    size: '0.3',
  },
  {
    title: 'DID모니터 호출연동 매뉴얼',
    file: 'DID_manual',
    extension: 'pdf',
    description: '',
    size: '4.1',
  },
  {
    title: '유통관리자 매뉴얼',
    file: 'Distribution_manual_210406',
    extension: 'pptx',
    description: '',
    size: '4.1',
  },
  {
    title: '포스 매뉴얼 ver1.2',
    file: 'Pos_manual_ver1.2',
    extension: 'pdf',
    description: '',
    size: '4.9',
  },
  {
    title: '키오스크 매뉴얼 ver1.4',
    file: 'Kiosk_manual_ver1.4',
    extension: 'pdf',
    description: '',
    size: '7.1',
  },
];
